module.exports = __webpack_public_path__ + "img/icon-12.da7d4828.png";